import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Crown } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
export function PackagesSection() {
  return <section id="paquetes" className="py-24 bg-white relative overflow-hidden" data-id="element-157">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-96 bg-[#FAFAF7] -z-10" data-id="element-158"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-161">
            Elige Tu Sistema de Transformación
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600" data-id="element-162">
            Mientras más completo, mejores y más rápidos los resultados
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto items-start" data-id="element-163">
          {/* CARD 1 - STARTER */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm hover:shadow-lg transition-all flex flex-col h-full mt-4 lg:mt-8" data-id="element-164">
            <div className="inline-block bg-gray-100 text-gray-600 px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6 w-max" data-id="element-165">
              Kit Inicio
            </div>

            <div className="aspect-[4/3] bg-gray-50 rounded-2xl mb-6 overflow-hidden" data-id="element-166">
              <img src="https://cdn.magicpatterns.com/uploads/vxLH9KwMf2R4NBjjcwszUV/ChatGPT_Image_21_abr_2026,_12_11_22_a.m..png" alt="Starter Kit" loading="lazy" className="w-full h-full object-contain p-2" data-id="element-167" />
            </div>

            <div className="mb-6" data-id="element-168">
              <h4 className="font-bold text-xs text-gray-400 uppercase tracking-widest mb-3" data-id="element-169">
                Incluye:
              </h4>
              <ul className="space-y-2" data-id="element-170">
                <li className="flex items-center text-gray-700 font-medium" data-id="element-171">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-172" /> Flora Liv
                  (Probiótico)
                </li>
                <li className="flex items-center text-gray-700 font-medium" data-id="element-173">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-174" /> Prunex 1
                  (Limpieza intestinal)
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-4 rounded-xl mb-8" data-id="element-175">
              <p className="text-sm text-gray-600 italic" data-id="element-176">
                "Ideal para comenzar tu transformación digestiva. Restaura tu
                flora y limpia tu intestino en 28 días"
              </p>
            </div>

            <div className="mt-auto" data-id="element-177">
              <div className="flex items-end mb-1" data-id="element-178">
                <span className="text-4xl font-bold text-[#1A1A1A]" data-id="element-179">$97</span>
              </div>
              <p className="text-gray-500 text-sm mb-6" data-id="element-180">+ $12 envío</p>

              <a href="https://elixirx.site/cart/43924707016838:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Kit Inicio', 97)} className="block w-full py-4 rounded-full font-bold text-[#1B5E20] border-2 border-[#1B5E20] hover:bg-[#1B5E20] hover:text-white transition-colors text-center" data-id="element-181">
                Comenzar Mi Transformación
              </a>
            </div>
          </motion.div>

          {/* CARD 2 - MOST POPULAR */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 border-4 border-[#F9A825] shadow-2xl relative flex flex-col h-full z-10" data-id="element-182">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#F9A825] text-white px-6 py-2 rounded-full text-sm font-bold flex items-center shadow-md w-max whitespace-nowrap" data-id="element-183">
              <Star size={16} className="mr-2 fill-current" data-id="element-184" />
              MÁS POPULAR - MEJOR VALOR
            </div>

            <div className="bg-[#4CAF50]/10 text-[#1B5E20] text-center py-2 -mx-8 -mt-2 mb-6 font-bold text-sm tracking-wide" data-id="element-185">
              ENVÍO GRATIS 🚚
            </div>

            <h3 className="text-2xl font-black text-[#1A1A1A] mb-4 text-center" data-id="element-186">
              GUT REST PROGRAM
            </h3>

            <div className="aspect-[4/3] bg-gray-50 rounded-2xl mb-6 overflow-hidden" data-id="element-187">
              <img src="https://cdn.magicpatterns.com/uploads/61htgVURWsyN4C9hMJZdn8/heylloyd-image-1776742286252.png" alt="Gut Rest Program" loading="lazy" className="w-full h-full object-contain p-2" data-id="element-188" />
            </div>

            <div className="mb-6" data-id="element-189">
              <h4 className="font-bold text-xs text-gray-400 uppercase tracking-widest mb-3" data-id="element-190">
                Incluye:
              </h4>
              <ul className="space-y-2" data-id="element-191">
                <li className="flex items-center text-gray-900 font-bold" data-id="element-192">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-193" /> Flora Liv
                  (Probiótico)
                </li>
                <li className="flex items-center text-gray-900 font-bold" data-id="element-194">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-195" /> Prunex 1
                  (Limpieza)
                </li>
                <li className="flex items-center text-gray-900 font-bold" data-id="element-196">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-197" /> Rexet
                  (Detox hígado)
                </li>
              </ul>
            </div>

            <div className="bg-[#F9A825]/10 p-4 rounded-xl mb-8 border border-[#F9A825]/20" data-id="element-198">
              <p className="text-sm text-gray-800 font-medium" data-id="element-199">
                "El sistema completo de digestión y detox. Flora + Limpieza +
                Hígado trabajando juntos para resultados visibles en 3 semanas"
              </p>
            </div>

            <div className="mt-auto" data-id="element-200">
              <div className="flex items-center mb-1" data-id="element-201">
                <span className="text-5xl font-black text-[#1A1A1A]" data-id="element-202">$141</span>
                <span className="text-xl text-gray-400 line-through ml-3" data-id="element-203">
                  $168
                </span>
              </div>
              <p className="text-[#4CAF50] font-bold text-sm mb-6" data-id="element-204">
                Ahorras $27 + Envío Gratis
              </p>

              <a href="https://elixirx.site/cart/43924713701510:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Gut Rest Program', 141)} className="block w-full py-4 rounded-full font-bold text-white bg-[#4CAF50] hover:bg-[#1B5E20] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-lg text-center" data-id="element-205">
                ¡Quiero Este Programa!
              </a>
            </div>
          </motion.div>

          {/* CARD 3 - PREMIUM */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#1A1A1A] rounded-3xl p-8 border border-gray-800 shadow-xl flex flex-col h-full mt-4 lg:mt-8 text-white relative overflow-hidden" data-id="element-206">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#F9A825]/10 rounded-full blur-2xl" data-id="element-207"></div>

            <div className="inline-flex items-center bg-white/10 text-[#FDD835] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-4 w-max border border-white/10" data-id="element-208">
              <Crown size={16} className="mr-2" data-id="element-209" />
              SISTEMA COMPLETO
            </div>

            <div className="flex flex-col gap-2 mb-6" data-id="element-210">
              <div className="bg-[#4CAF50]/20 text-[#4CAF50] text-center py-1.5 rounded-md font-bold text-xs tracking-wide border border-[#4CAF50]/30" data-id="element-211">
                ENVÍO GRATIS 🚚
              </div>
              <div className="bg-[#F9A825]/20 text-[#FDD835] text-center py-1.5 rounded-md font-bold text-xs tracking-wide border border-[#F9A825]/30" data-id="element-212">
                PRUNEX DE REGALO 🎁
              </div>
            </div>

            <h3 className="text-xl font-black text-white mb-4 leading-tight" data-id="element-213">
              ADVANCED GUT + RECOVERY SYSTEM
            </h3>

            <div className="aspect-[4/3] bg-white/5 rounded-2xl mb-6 overflow-hidden border border-white/10" data-id="element-214">
              <img src="https://cdn.magicpatterns.com/uploads/dos3wJyyeSChTusvfSxKgX/Gemini_Generated_Image_dg5murdg5murdg5m.png" alt="Premium System" loading="lazy" className="w-full h-full object-contain p-2" data-id="element-215" />
            </div>

            <div className="mb-6" data-id="element-216">
              <h4 className="font-bold text-xs text-gray-400 uppercase tracking-widest mb-3" data-id="element-217">
                Incluye:
              </h4>
              <ul className="space-y-2" data-id="element-218">
                <li className="flex items-center text-gray-200" data-id="element-219">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-220" /> Flora Liv
                  (Probiótico)
                </li>
                <li className="flex items-center text-gray-200" data-id="element-221">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-222" /> Rexet
                  (Detox)
                </li>
                <li className="flex items-center text-gray-200" data-id="element-223">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-224" /> Golden FLX
                  (Antiinflamatorio)
                </li>
                <li className="flex items-center text-gray-200" data-id="element-225">
                  <Check size={18} className="text-[#4CAF50] mr-2" data-id="element-226" /> Youth
                  Elixir (Anti-edad)
                </li>
                <li className="flex items-center text-[#FDD835] font-bold mt-2" data-id="element-227">
                  <Check size={18} className="text-[#FDD835] mr-2" data-id="element-228" /> 🎁 Prunex
                  1 DE REGALO
                </li>
              </ul>
            </div>

            <div className="bg-white/5 p-4 rounded-xl mb-8 border border-white/10" data-id="element-229">
              <p className="text-sm text-gray-300" data-id="element-230">
                "Transformación total: digestión, detox, inflamación, energía y
                anti-edad. El sistema que lo tiene todo"
              </p>
            </div>

            <div className="mt-auto" data-id="element-231">
              <div className="flex items-center mb-1" data-id="element-232">
                <span className="text-4xl font-black text-white" data-id="element-233">$189.50</span>
                <span className="text-lg text-gray-500 line-through ml-3" data-id="element-234">
                  $245
                </span>
              </div>
              <p className="text-[#FDD835] font-bold text-sm mb-6" data-id="element-235">
                Ahorras $56 + Envío Gratis + Regalo
              </p>

              <a href="https://elixirx.site/cart/43924738179206:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Advanced Gut + Recovery System', 189.5)} className="block w-full py-4 rounded-full font-bold text-[#1A1A1A] bg-[#F9A825] hover:bg-[#FDD835] transition-colors shadow-lg text-center" data-id="element-236">
                Obtener Sistema Completo
              </a>
            </div>
          </motion.div>
        </div>

        {/* Included Services Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 bg-[#1B5E20]/5 border border-[#1B5E20]/10 rounded-3xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-237">
          <h3 className="text-center text-xl font-bold text-[#1A1A1A] mb-8" data-id="element-238">
            🎁 Todos los paquetes incluyen:
          </h3>
          <div className="grid sm:grid-cols-3 gap-6" data-id="element-239">
            <div className="flex flex-col items-center text-center" data-id="element-240">
              <div className="text-3xl mb-3" data-id="element-241">💬</div>
              <h4 className="font-bold text-[#1A1A1A] mb-1" data-id="element-242">
                Asesoría por WhatsApp
              </h4>
              <p className="text-sm text-gray-600" data-id="element-243">
                Asesoramiento personalizado para el consumo correcto de cada
                producto y seguimiento continuo por WhatsApp
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-244">
              <div className="text-3xl mb-3" data-id="element-245">👥</div>
              <h4 className="font-bold text-[#1A1A1A] mb-1" data-id="element-246">
                Comunidad de Salud
              </h4>
              <p className="text-sm text-gray-600" data-id="element-247">
                Acceso a nuestra comunidad donde recibirás charlas de salud y
                bienestar si así lo deseas
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-248">
              <div className="text-3xl mb-3" data-id="element-249">📧</div>
              <h4 className="font-bold text-[#1A1A1A] mb-1" data-id="element-250">
                Confirmación por Correo
              </h4>
              <p className="text-sm text-gray-600" data-id="element-251">
                Recibirás confirmación de compra y número de rastreo directo a
                tu email
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}